import React from 'react';
import 'react-dates/lib/css/_datepicker.css';
import { Button, Input } from 'semantic-ui-react';
import { errorInput, seminary } from 'src/components/helpers';
import useRememberCredentials from 'src/components/helpers/useRememberCredentials';
import RememberCredentialsCheckbox from 'src/components/helpers/RememberCredentialsCheckbox';
import { withRouter } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { RegistrationForm } from 'src/assets/styles/components/Registration';

const MemberLogGroup = (props) => {
  const { inputs, setInputs, next, parsedQueryString, loading, checkGroupGuest } = props;
  const [errorInputs, set_errorInputs] = React.useState({});
  const { rememberCredentials, setRememberCredentials, persistCredentials } =
    useRememberCredentials({ setInputs });

  const params = props.match.params;

  const verifyForm = () => {
    let mandatoryInputs = ['identification', 'phone'];
    let errorInputs = {};

    mandatoryInputs.forEach((input) => {
      errorInputs = errorInput({
        errorInputs,
        input: { name: input, value: inputs[input] },
      });
    });

    if (inputs['identification'] && inputs['identification'].length <= 5) {
      errorInputs = errorInput({
        errorInputs,
        input: {
          name: 'identification',
          value: inputs['identification'].length >= 5,
        },
      });
    }

    set_errorInputs(errorInputs);
    return Object.values(errorInputs).includes(true);
  };

  React.useEffect(() => {
    if (!parsedQueryString.activityName && inputs.kindgroup) {
      props.history.push(`?kindgroup=${inputs.kindgroup}`);
    }
  }, [inputs.kindgroup]);

  React.useEffect(() => {
    if (
      parsedQueryString.identification &&
      parsedQueryString.phone &&
      inputs.identification &&
      inputs.phone
    ) {
      enterReservation({ preventDefault: () => {} });
    }
  }, [inputs.identification]);

  const enterReservation = async (e) => {
    e.preventDefault();
    if (verifyForm()) return;

    persistCredentials({
      identification: inputs.identification,
      phone: inputs.phone,
    });

    await checkGroupGuest({
      identification: inputs.identification,
      phone: inputs.phone,
      person: 'person1',
      updateStep: true,
      nextStep: next,
    });
  };

  const handleInputs = (event) => {
    let value = event.target.value;
    let name = event.target.name;
    setInputs({ ...inputs, [name]: value });
  };

  if (window.location.pathname.includes('crecer') && !seminary.includes(params?.seminary)) {
    return (
      <RegistrationForm>
        <h2>Error en el enlace</h2>
        <p>
          Si desea registrarse en Para Siempre{' '}
          <Link to={'/crecer/registrarse/Para_Siempre._'}>haz clic aquí</Link>
        </p>
        <p>
          Si desea registrarse en Transformación Empresarial{' '}
          <Link to={'/crecer/registrarse/Transformacion_Empresarial._'}>haz clic aquí</Link>
        </p>
      </RegistrationForm>
    );
  }

  return (
    <RegistrationForm className="member-log-form" onSubmit={(e) => enterReservation(e)}>
      <label className="member-log-title">Escribe tus datos</label>
      <p className="member-log-subtitle">
        Ingresa tu identificación y celular para continuar con el registro.
      </p>

      {Object.values(errorInputs).includes(true) && (
        <p className="member-log-error">Por favor verifica los campos en rojo.</p>
      )}

      <div className="member-log-fields">
        <Input
          onChange={handleInputs}
          name={'identification'}
          value={inputs.identification}
          type="number"
          placeholder="Identificación"
          id="identification"
          className={`Registration__input Registration__input-identification ${
            errorInputs['identification'] ? 'error' : ''
          }`}
        />
        <Input
          placeholder="Celular"
          id="phone"
          name={'phone'}
          type="number"
          className={`Registration__input Registration__input-phone ${
            errorInputs['phone'] ? 'error' : ''
          }`}
          value={inputs.phone}
          onChange={handleInputs}
        />
      </div>

      <RememberCredentialsCheckbox
        checked={rememberCredentials}
        onChange={setRememberCredentials}
      />

      <Button className="member-log-submit" primary disabled={loading} type="submit">
        Entrar
      </Button>
    </RegistrationForm>
  );
};

export default withRouter(MemberLogGroup);
